"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqData = [{
  question: "Are your dental services affordable?",
  answer: "Yes, Smart Choice Dentures & Implants specializes in providing high-quality, efficient dental care at affordable rates for the El Monte community. We offer various financing options to ensure you get the smile you deserve without financial stress."
}, {
  question: "What is the process for getting new dentures?",
  answer: "The process begins with a consultation where we assess your needs. From there, we take precise impressions and custom-craft your dentures for a natural look and comfortable fit, often with faster turnaround times than traditional clinics."
}, {
  question: "Do you offer sedation for extractions and implants?",
  answer: "Absolutely. We understand dental anxiety, which is why we offer safe sedation options for extractions and implant procedures to ensure your experience is as comfortable and stress-free as possible."
}, {
  question: "How long do dental implants take to heal?",
  answer: "Healing times vary by patient, but typically the osseointegration process takes 3 to 6 months. We monitor your progress closely throughout the entire journey to ensure the highest success rate and clinical excellence."
}, {
  question: "Where is Smart Choice Dentures & Implants located?",
  answer: "We are conveniently located in El Monte, California. Our modern facility is designed to provide a warm, welcoming environment for all our patients seeking professional dental solutions in the local area."
}];
export default function Faqs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="26061" id="frequently-asked-questions" ref={ref} className={cn("relative w-full py-20 lg:py-32 overflow-hidden", "bg-secondary/40", "transition-opacity duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full opacity-20 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-primary/10 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-accent/20 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-semibold font-serif tracking-tight text-foreground mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-muted-foreground text-lg font-sans">
              Everything you need to know about our affordable dental care, dentures, and implant solutions.
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-border/50 bg-card/80 backdrop-blur-sm px-6 rounded-2xl shadow-sm hover:border-primary/30 transition-colors duration-300">
                <AccordionTrigger className="text-left font-sans text-lg font-semibold text-foreground hover:text-primary hover:no-underline py-6">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6 font-sans">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}